import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { PERMISSION_ACTIONS, PLATFORM_PERMISSIONS } from '@thinknet-gmbh/platform-common';
import {
  Button,
  ICONS,
  PLATFORM_THEME_COLORS,
  NOTIFICATION_TYPE,
  showNotification,
} from '@thinknet-gmbh/platform-common-ui';

import { ROUTES } from 'src/components/app/app-routes.constants';
import { SETTINGS_PAGES } from 'src/pages/settings/settings.constants';
import PermissionCheck from 'src/components/permission-check';

import { ButtonsWrapper } from './company-expanded-list.styles';

const CompanyActionButtons = ({
  company,
  companies,
  setCompanyToDelete,
}: {
  company: any;
  companies?: any;
  setCompanyToDelete?: ({ _id, name }: { _id: string; name: string }) => void;
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation(['common', 'settings']);

  const onDeleteClickHandler = () => {
    if (companies.length) {
      // Interim solution
      showNotification({
        type: NOTIFICATION_TYPE.error,
        message: t('settings:company.notifications.cantDeleteSubsidiaryCompanyMessage'),
        description: t('settings:company.notifications.cantDeleteSubsidiaryCompanyDescription'),
      });
    } else {
      if (setCompanyToDelete) {
        setCompanyToDelete({ _id: company._id, name: company.name });
      }
    }
  };

  return (
    <ButtonsWrapper>
      {company.parentCompanyId && (
        <PermissionCheck
          permission={PLATFORM_PERMISSIONS.companyManagement}
          action={PERMISSION_ACTIONS.delete}
          createdBy={company.createdBy}
        >
          <Button
            type="text"
            icon={ICONS.trash}
            iconColor={PLATFORM_THEME_COLORS.tone.red}
            onClick={onDeleteClickHandler}
          >
            {t('settings:company.buttons.deleteCompany')}
          </Button>
        </PermissionCheck>
      )}
      <PermissionCheck
        permission={PLATFORM_PERMISSIONS.companyManagement}
        action={PERMISSION_ACTIONS.create}
      >
        <Button
          type="primary"
          ghost
          icon={ICONS.plus}
          iconColor={PLATFORM_THEME_COLORS.primary.blue}
          onClick={() =>
            navigate(`${ROUTES.settings}/${SETTINGS_PAGES.addSubsidiaryCompany}`, {
              state: { parentCompanyId: company._id },
            })
          }
        >
          {t('settings:company.buttons.addSubsidiaryCompany')}
        </Button>
      </PermissionCheck>
      <PermissionCheck
        permission={PLATFORM_PERMISSIONS.companyManagement}
        action={PERMISSION_ACTIONS.update}
        createdBy={company.createdBy}
      >
        <Button
          type="primary"
          ghost
          icon={ICONS.editAlt}
          iconColor={PLATFORM_THEME_COLORS.primary.blue}
          onClick={() =>
            navigate(
              `${ROUTES.settings}?type=${SETTINGS_PAGES.editCompanyProfile}&id=${company._id}`
            )
          }
        >
          {t('common:buttons.edit')}
        </Button>
      </PermissionCheck>
    </ButtonsWrapper>
  );
};

export default CompanyActionButtons;
